import { ICharacterState } from '../../interfaces/ICharacterState';
import { CharacterStateBase } from "./CharacterStateBase";
import { Character } from "../Character";
import { CharacterAnimation } from "../../enums/CharacterAnimation";
import { Walk } from "./Walk";


export class Hurt extends CharacterStateBase implements ICharacterState {

    constructor(character: Character) {
        super(character);
        character.takeDamage(50);
        this.playAnimation(CharacterAnimation.Hurt, 0.1, true, false);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
    }

    public onInputChange(): void {
        super.onInputChange();

        if (this.anyDirection()) { // If we're in the hurt state, we can walk away
            if (this.character.simulation.velocity.length() > 0.5) {
                this.character.setState(new Walk(this.character));
            } else {
                this.setAppropriateStartWalkState();
            }
        }
    }
}
